module.exports = __webpack_public_path__ + "img/hp_enterprise_small.fw.4921a735.png";